import { getMessageFromError } from '@pro4-erp/core-web';
import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getNextCloudUrl } from '../api/getUrlToNextCloud';

type NCTypes = {
  visitUid: string;
  woUid: string;
  label?: string;
};

const NextCloudButton = ({ visitUid, woUid, label }: NCTypes) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { mutate } = useMutation({
    mutationFn: getNextCloudUrl,
    onSuccess: (data) => {
      if (data?.status && !data?.url) {
        return;
      }
      if (data?.status && data?.url) {
        window.open(data.url, '_blank');
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar(getMessageFromError(error), { variant: 'error' });
    },
  });

  const openNC = async () => {
    mutate({
      visitUid,
      woUid,
    });
  };

  return (
    <Button onClick={openNC} type="button" variant="contained">
      {label === 'auditor'
        ? t('Visit files', { defaultValue: 'Visit files' })
        : t('Manage files', { defaultValue: 'Manage files' })}
    </Button>
  );
};

export default NextCloudButton;
